// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"TabB_TheComp__ZqYKk"};